/* One entry into the installed review provider; no review data is collected here. */
(function () {
  'use strict';
  var pending = false;
  function nativeButton() {
    var root = document.getElementById('fulfilled-reviews-all');
    if (!root) return null;
    return Array.from(root.querySelectorAll('button, a')).find(function (element) {
      return /^write a review$/i.test(element.textContent.trim()) && !element.disabled;
    }) || null;
  }
  function openReview(trigger) {
    if (pending) return;
    document.documentElement.classList.add('fp-reviewing');
    pending = true;
    var status = document.querySelector('[data-fp-review-status]');
    if (status) status.textContent = 'Opening your review form…';
    if (trigger) trigger.setAttribute('aria-busy', 'true');
    var poll;
    var timer;
    function finish() {
      pending = false;
      window.clearInterval(poll);
      window.clearTimeout(timer);
      if (trigger) trigger.removeAttribute('aria-busy');
    }
    function tryOpen() {
      var button = nativeButton();
      if (!button) return false;
      finish();
      if (status) status.textContent = '';
      button.click();
      return true;
    }
    if (tryOpen()) return;
    // The provider may mount its root late or enable an existing button.
    // Bound retries to this request rather than observing the whole storefront.
    poll = window.setInterval(tryOpen, 100);
    timer = window.setTimeout(function () {
      finish();
      if (status) {
        status.textContent = 'The review form could not load. Please try again, or ';
        var help = document.createElement('a');
        help.href = '/pages/contact';
        help.textContent = 'contact us for help';
        status.appendChild(help);
        status.appendChild(document.createTextNode('.'));
      }
    }, 12000);
  }
  document.querySelectorAll('[data-fp-write-review]').forEach(function (link) {
    link.addEventListener('click', function (event) {
      event.preventDefault();
      openReview(link);
    });
  });
  var query = new URLSearchParams(window.location.search);
  if (query.get('write_review') === '1' && document.querySelector('[data-fp-write-review]')) {
    openReview(document.querySelector('[data-fp-write-review]'));
  }

  // FP40 2026-10-08 (G3). On /pages/reviews the product picker is <dialog id="write-review">
  // (snippets/fp-review-selector.liquid), opened by every [data-fp-review-open] link. Without
  // showModal() or the :modal selector the CSS keys on, it is shown inline (.is-inline) and the links
  // keep their plain #write-review jump. The scroll lock and the mascot rule are CSS keyed on
  // :modal, so nothing here can leave the page locked if a listener never runs.
  var selector = document.querySelector('[data-fp-review-selector]');
  if (!selector) return;
  var HASH = '#' + selector.id;
  var modal = typeof selector.showModal === 'function' && !!(window.CSS && CSS.supports && CSS.supports('selector(:modal)'));
  var triggers = Array.from(document.querySelectorAll('[data-fp-review-open]'));
  var lastTrigger = null;
  var downOnBackdrop = false;

  function openPicker(trigger) {
    if (!modal || selector.open) return;
    lastTrigger = trigger || null;
    selector.showModal();
  }

  if (!modal) {
    // FP40 review fix 2026-10-08 (L5). Inline by class, never by [open]: a permanent [open] read as
    // "a dialog is up" to every dialog[open] check on the page (fp-mascot.js pageIsClear, the
    // fp-mascot.css hide rule, the FP entrances), so FP stayed hidden for the whole visit.
    selector.classList.add('is-inline');
    Array.from(selector.querySelectorAll('[data-fp-review-close]')).forEach(function (button) { button.hidden = true; });
  } else {
    triggers.forEach(function (link) {
      link.setAttribute('aria-haspopup', 'dialog');
      link.setAttribute('aria-controls', selector.id);
      link.addEventListener('click', function (event) {
        // A modified click keeps the browser's own handling (new tab or window); that page opens
        // the dialog from its #write-review hash.
        if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        openPicker(link);
      });
    });
    Array.from(selector.querySelectorAll('[data-fp-review-close]')).forEach(function (button) {
      button.addEventListener('click', function () { selector.close(); });
    });
    // Backdrop only: the dialog has no padding and its two children fill it, so a target of the
    // dialog itself is the backdrop. Both ends must be there, or a text selection dragged out of
    // the box would close it.
    selector.addEventListener('pointerdown', function (event) { downOnBackdrop = event.target === selector; });
    selector.addEventListener('click', function (event) {
      if (event.target === selector && downOnBackdrop) selector.close();
      downOnBackdrop = false;
    });
    selector.addEventListener('close', function () {
      // A deep link has no trigger: fall back to the hero button, which is on screen at load.
      var back = lastTrigger && document.contains(lastTrigger) ? lastTrigger : triggers[0];
      lastTrigger = null;
      // Drop the hash so a reload or Back does not reopen what the shopper just closed.
      if (window.location.hash === HASH && window.history && window.history.replaceState) {
        window.history.replaceState(window.history.state, '', window.location.pathname + window.location.search);
      }
      if (back) back.focus();
    });
    window.addEventListener('hashchange', function () {
      if (window.location.hash === HASH) openPicker(null);
    });
  }

  var productId = query.get('product_id');
  if (productId && /^[1-9][0-9]*$/.test(productId)) {
    var match = Array.from(selector.querySelectorAll('[data-fp-review-product]')).find(function (link) {
      return link.dataset.fpReviewProduct === productId;
    });
    if (match) {
      window.location.replace(match.href);
      return;
    }
    var message = selector.querySelector('[data-fp-product-status]');
    if (message) message.textContent = 'We couldn’t locate your product here. Browse the products below or contact us for help.';
    // The picker is closed by default now, so open it or the message is never seen.
    openPicker(null);
    return;
  }
  if (window.location.hash === HASH) openPicker(null);
})();
